import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@/shared/ui';
import { TableCell } from './TableCell';
import { TableRow } from './TableRow';

type TableEmptyRowProps = {
  colSpan: number;
  showLastBorderBottom: boolean;
  emptyRender?: ReactNode;
};

/**
 * データがない場合の空状態行をレンダリングするコンポーネント
 */
export const TableEmptyRow = ({
  colSpan,
  showLastBorderBottom,
  emptyRender,
}: TableEmptyRowProps) => {
  const { t } = useTranslation();

  return (
    <TableRow className={showLastBorderBottom ? '' : 'border-b-0'}>
      <TableCell colSpan={colSpan} className="h-24 text-center">
        {emptyRender ?? (
          <div className="flex w-full items-center justify-center">
            <Text>{t('common.table.no-data')}</Text>
          </div>
        )}
      </TableCell>
    </TableRow>
  );
};
